export const GET_LICENSES_REQUEST = "GET_LICENSES_REQUEST";
export const GET_LICENSES_SUCCESS = "GET_LICENSES_SUCCESS";
export const GET_LICENSES_FAIL = "GET_LICENSES_FAIL";
